module.exports = __webpack_public_path__ + "static/media/Account_Select_Individual.a7f732cd.svg";